export class HttpError extends Error {
  status: number;
  details?: unknown;
  constructor(status: number, message: string, details?: unknown) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.details = details;
  }
}

export async function getJson<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...init,
    method: "GET",
    headers: {
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    let details: unknown;
    try {
      details = await res.json();
    } catch {
      /* ignore non-JSON error bodies */
    }
    throw new HttpError(res.status, res.statusText || "HTTP Error", details);
  }
  const text = await res.text();
  return (text ? JSON.parse(text) : undefined) as T;
}

export async function postJson<T, B = unknown>(url: string, body?: B, init?: RequestInit) {
  const res = await fetch(url, {
    ...init,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let details: unknown;
    try {
      details = await res.json();
    } catch {}
    throw new HttpError(res.status, res.statusText || "HTTP Error", details);
  }
  const text = await res.text();
  return (text ? JSON.parse(text) : undefined) as T;
}

// Add putJson, patchJson, deleteJson similarly if needed.